import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames/bind';
import moment from 'moment';
import { Table, Select, InputNumber, Space } from 'antd';

import styles from './card.module.scss';

const cx = classNames.bind(styles);

const OPTIONS = {
  TANK: '용기',
  VELVE: '밸브',
};

const ByInspectionDate = ({ data: tanks, enableNavigation = true }) => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(OPTIONS.TANK);
  const [acceptableDays, setAcceptableDays] = useState(30);

  const handleChangeSelectOption = (value) => {
    setSelectedOption(value);
  };

  const handleChangeAcceptableDays = (value) => {
    const enteredValue = Number(value);

    if (!isNaN(enteredValue)) {
      setAcceptableDays(enteredValue);
    }
  };

  const columns = [
    {
      key: 'serialNo',
      title: '일련번호',
      render: (_, record) => (selectedOption === OPTIONS.TANK ? record.serialNo : record.velveSerialNo),
    },
    {
      key: 'inspectionDate',
      title: '점검일자',
      render: (_, record) => record.inspectionDate.format('YYYY-MM-DD'),
      width: 100,
      align: 'center',
    },
    {
      key: 'remainingDays',
      title: '잔여일수',
      width: 80,
      align: 'center',
      render: (_, record) => record.remainingDays,
    },
  ];

  const data = useMemo(() => {
    if (tanks === undefined) return;

    return (
      tanks
        // 임시, 검사, 폐기 상태 용기 제외
        .filter((tank) => !['DRAFT', 'INSPECTING', 'RETIRED'].includes(tank.useStatus))
        .map((tank) => {
          const sourceDate = selectedOption === OPTIONS.TANK ? tank.manufacturedDate : tank.velveExpireDate;
          const inspectionDate = moment(sourceDate, 'YYYYMMDD');

          // 용기 5년, 밸브 1년
          const incrementYears = selectedOption === OPTIONS.TANK ? 5 : 1;

          while (inspectionDate.isBefore(moment())) {
            inspectionDate.add(incrementYears, 'years');
          }

          const remainingDays = moment(inspectionDate).diff(moment(), 'day') + 1;

          return {
            ...tank,
            inspectionDate,
            remainingDays,
          };
        })
        // 점검일자까지 잔여일수가 입력일 이하인 데이터
        .filter((tank) => tank.remainingDays <= acceptableDays)
    );
  }, [tanks, selectedOption, acceptableDays]);

  return (
    <div className={cx('container')}>
      <div className={cx('header')}>
        <div className={cx('title')}>점검기한 만료</div>
        <Space>
          <Select
            style={{ width: 80 }}
            value={selectedOption}
            onChange={handleChangeSelectOption}
            options={[
              { label: '용기', value: '용기' },
              { label: '밸브', value: '밸브' },
            ]}
          />
          <Space size={6}>
            <InputNumber
              style={{ width: 60 }}
              value={acceptableDays}
              onChange={handleChangeAcceptableDays}
              maxLength={3}
            />
            <span className={cx('post')}>일 이내</span>
          </Space>
        </Space>
      </div>
      <div className={cx('body')}>
        <Table
          onRow={
            enableNavigation
              ? (record) => {
                  return {
                    onClick: () => navigate(`/tanks/${record.rid}`),
                  };
                }
              : undefined
          }
          columns={columns}
          scroll={{
            x: 300,
            y: 280,
          }}
          virtual
          dataSource={data}
          pagination={false}
          rowKey={'rid'}
        />
      </div>
    </div>
  );
};

export default ByInspectionDate;
